import './DeactivateAffiliateModal.scss';
import React, {
  KeyboardEvent as ReactKeyboardEvent,
  useEffect,
  useState,
} from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { ModalBody, ModalHeader, ModalFooter } from '../modal-helpers';
import Button from '../../buttons/DeprecatedButton/DeprecatedButton';
import AffiliatesCRUDActions from '@mm/state/actions/AffiliatesCRUDActions';
import { modalDescription, modalTitle } from './constants';
import { ENTER_CODE } from '@mm/constants/keys-codes';
import { Dispatch } from 'redux';
import { StoreState } from '@mm/state/store-interfaces';
import { ModalInstanceProps } from '../interfaces';
import { AffiliateModel } from '@mm/state/model/AffiliateModel';

type OuterProps = ModalInstanceProps & {
  affiliate: AffiliateModel;
};

type InnerProps = ReturnType<typeof mapDispatchToProps>;

type Props = OuterProps & InnerProps;

const DeactivateAffiliateModal = (props: Props) => {
  const { deactivateAffiliate, closeModal, affiliate } = props;
  const [isDeactivating, setIsDeactivating] = useState(false);

  const onDeactivate = async () => {
    try {
      setIsDeactivating(true);
      await deactivateAffiliate(affiliate.id);
      closeModal();
    } catch {
      setIsDeactivating(false);
    }
  };

  const onKeyDown: EventListener = (
    e: ReactKeyboardEvent<Document> & KeyboardEvent,
  ) => {
    if (e.keyCode === ENTER_CODE) {
      onDeactivate();
    }
  };

  useEffect(() => {
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, []);

  return (
    <div className="deactivate-affiliate-modal">
      <ModalHeader className="deactivate-affiliate-modal__header">
        {modalTitle}
      </ModalHeader>
      <ModalBody className="deactivate-affiliate-modal__body">
        {modalDescription}
      </ModalBody>
      <ModalFooter>
        <Button invert onClick={closeModal}>
          Go Back
        </Button>

        <Button disabled={isDeactivating} red onClick={onDeactivate}>
          Deactivate
        </Button>
      </ModalFooter>
    </div>
  );
};

const mapDispatchToProps = (dispatch: Dispatch<StoreState>) => ({
  deactivateAffiliate: (id: number) =>
    dispatch(AffiliatesCRUDActions.delete(id)),
});

const enhance = compose<InnerProps, OuterProps>(
  connect(null, mapDispatchToProps),
);

export default enhance(DeactivateAffiliateModal);
